

export function* redirect({ history, path }) {
  history.push(path)
}


// WEBPACK FOOTER //
// ./src/sagas/redirect-saga.js